// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const bn: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'কীভাবে খেলবে',
  'howto.pieces.heading': 'অংশগুলো',
  'howto.pieces.source': 'উৎস',
  'howto.pieces.mirror': 'আয়না',
  'howto.pieces.switch': 'সুইচ',
  'howto.pieces.exit': 'বাহির',
  'howto.pieces.wall': 'দেয়াল',
  'howto.controls.heading': 'নিয়ন্ত্রণ',
  'howto.controls.clickSlot.line1': 'খোপে ক্লিক করো',
  'howto.controls.clickSlot.line2': 'আয়না বসাও',
  'howto.controls.dragMirror.line1': 'আয়না টানো',
  'howto.controls.dragMirror.line2': 'ঘোরাও',
  'howto.controls.rightClick.line1': 'ডান-ক্লিক',
  'howto.controls.rightClick.line2': 'আয়না সরাও',
  'howto.controls.hint': 'মাউস হুইল: 1° সূক্ষ্ম ঘূর্ণন।   আয়নায় ট্যাপ: 15° ঘূর্ণন।',
  'howto.objective.line1': 'প্রতিটি সুইচ জ্বালাও — বাহিরের তালা খুলে যাবে।',
  'howto.objective.line2': 'তারপর বাহিরে ক্লিক করো। যত কম আয়নায় পারো সমাধান করো।',

  'howtoColor.title': 'রং এবং প্রিজম',
  'howtoColor.pieces.heading': 'নতুন অংশ',
  'howtoColor.pieces.prism': 'প্রিজম',
  'howtoColor.pieces.redSwitch': 'লাল সুইচ',
  'howtoColor.pieces.yellowSwitch': 'হলুদ সুইচ',
  'howtoColor.pieces.whiteSwitch': 'সাদা সুইচ',
  'howtoColor.how.heading': 'এরা কীভাবে কাজ করে',
  'howtoColor.how.line1': 'একটি সাদা রশ্মি একসাথে লাল, সবুজ ও নীল আলো বহন করে।',
  'howtoColor.how.line2': 'প্রিজম সাদা আলোকে তার তিনটি পাশ বরাবর তিনটি রঙিন রশ্মিতে ভাগ করে।',
  'howtoColor.how.line3': 'বসানো প্রিজমে ক্লিক করে তার প্রবেশ-মুখ ঘুরাও।',
  'howtoColor.switches.line1': 'সুইচে রঙিন বিন্দু দেখায় — সেটাই তার চাই-করা রং।',
  'howtoColor.switches.line2': 'হলুদ সুইচ (লাল + সবুজ বিন্দু) চায় দুটো রং একসাথে।',
  'howtoColor.switches.line3': 'সাদা সুইচ (তিনটে রং) চায় লাল, সবুজ ও নীল একসাথে।',

  'options.hints.label': 'ধাঁধায় ইঙ্গিত-কোণ দেখাও',
  'options.hints.help': 'প্রতিটি প্রতিফলনে আগত ও প্রতিফলিত রশ্মির মধ্যকার কোণ দেখায়।',

  'level.01-intro.title': 'হ্যালো আলো',
  'level.02-two-mirrors.title': 'দুটি মোড়',
  'level.03-corner.title': 'পথে দেয়াল',
  'level.04-two-targets.title': 'দুটি লক্ষ্য',
  'level.05-tight.title': 'সংকীর্ণ',
  'level.06-hello-color.title': 'হ্যালো রং',
  'level.07-pick-a-side.title': 'একটি পাশ বেছে নাও',
  'level.08-yellow.title': 'হলুদ',
  'level.09-magenta.title': 'ম্যাজেন্টা',
  'level.10-spectrum.title': 'বর্ণালী',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'সমকোণ',
  'puzzle.hint.angleType.acute': 'সূক্ষ্ম',
  'puzzle.hint.angleType.obtuse': 'স্থূল',
  'puzzle.hint.label': '{angle}°\n{type}',
};
